import { render, staticRenderFns } from "./RealEstateTypesForm.vue?vue&type=template&id=7c6478fa&scoped=true&"
import script from "./RealEstateTypesForm.vue?vue&type=script&lang=js&"
export * from "./RealEstateTypesForm.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateTypesForm.vue?vue&type=style&index=0&id=7c6478fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6478fa",
  null
  
)

export default component.exports